import { render, staticRenderFns } from "./IconEmergencyOn.vue?vue&type=template&id=0a252a04&"
import script from "./IconEmergencyOn.vue?vue&type=script&lang=js&"
export * from "./IconEmergencyOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports